// extracted by mini-css-extract-plugin
module.exports = {"customSelect":"Livesearch_customSelect__irTsK"};